import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { AuthConfig } from '../api/types';

export const CALLBACK_PATH = '/auth/callback';

export interface ReturnState {
  returnTo?: string;
}

/**
 * Authorization code flow with PKCE. Tokens are renewed with the refresh token
 * (`offline_access`); no silent-renew iframe is configured.
 */
export function createUserManager(auth: Extract<AuthConfig, { mode: 'jwt' }>): UserManager {
  const origin = window.location.origin;
  return new UserManager({
    authority: auth.authority,
    client_id: auth.clientId,
    redirect_uri: `${origin}${CALLBACK_PATH}`,
    post_logout_redirect_uri: `${origin}/`,
    response_type: 'code',
    scope: ['openid', 'profile', 'offline_access', ...auth.scopes].join(' '),
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
}
